import {html, LitElement} from "lit";
import {customElement} from "lit/decorators.js";
import {sidebarOnboardingHelpStyles} from "./SidebarOnboardingHelp.styles.js";
import Utils from "../../main/utils/index.js";
import Data from "../../main/data/index.js";
import Integration from "../../integrations/integration/index.js";

@customElement("pn-sidebar-onboarding-help")
export class SidebarOnboardingHelp extends LitElement {
	static styles = [sidebarOnboardingHelpStyles];

	render() {
		switch (Integration.name) {
			case "proquest":
				return this.renderProQuest();
			default:
				return this.renderDefault();
		}
	}

	renderProQuest() {
		return html`
			<div class="msg-help">
				<div class="msg-sidebar-help-inner">
					<div class="msg-help-header">Organize your Congressional Research with&nbsp;<strong>PowerNotes</strong></div>
					<ul>
						<li>
							<span
								class="icon"
								style="mask-image: url(${Utils.Common.imgPath("icon_highlighter.svg")}); background-color: var(--pn-color-yellow);"
							></span>
							Use your cursor to highlight key points from a source.
							Categorize your highlight by adding it to a named topic.
						</li>
						<li>
							<span
								class="icon"
								style="mask-image: url(${Utils.Common.imgPath("icon_freeform_note.svg")}); background-color: var(--pn-color-dark-rock);"
							></span>
							Annotate your highlights. Citations will be automatically generated.
						</li>
						<li>
							<span
								class="icon"
								style="mask-image: url(${Utils.Common.imgPath("icon_organized.svg")}); background-color: var(--pn-color-lavander);"
							></span>
							Your organized highlights, annotations and citation information
							will create a structured outline for your papers or projects.
						</li>
					</ul>
					<div>
						New to PowerNotes?
						<a
							href=${Data.app.config?.urls.promo + "resources/help-support"}
							target="_blank"
						>Learn more</a>
					</div>
				</div>
			</div>
        `;
	}

	renderDefault() {
		return html`
			<div class="msg-help">
				<div class="msg-sidebar-help-inner">
					<div class="msg-help-header">Make the Most Out of PowerNotes</div>
					<ul>
						<li>
							<span
								class="icon"
								style="mask-image: url(${Utils.Common.imgPath("icon_create_projects.svg")})"
							></span>
							<strong>Create and switch Projects</strong> with the menu at the top of this sidebar.
						</li>
						<li>
							<span
								class="icon"
								style="mask-image: url(${Utils.Common.imgPath("icon_highlight_text.svg")})"
							></span>
							<strong>View your Outline</strong> by clicking on the Project Outline link in the
							navigation bar.
						</li>
						<li>
							<img
								alt="PowerNotes logo"
								src="${Utils.Common.imgPath("powernotes-circle-logo-gray@2x.png")}"
							/>
							<strong>Manage your Projects</strong> by clicking on the PowerNotes logo above.
						</li>
					</ul>
					<div>
						New to PowerNotes?
						<a
							href=${Data.app.config?.urls.promo + "resources/help-support"}
							target="_blank"
						>Learn more</a>
					</div>
				</div>
			</div>
        `;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-sidebar-onboarding-help": SidebarOnboardingHelp;
	}
}
